/**
 * SurveyResultsModalHeader Component
 * Custom header for the Surveys & Feedback modal with stat boxes and coach avatar.
 * Pattern matches SessionDetailHeader.tsx
 */

import { ActionIcon } from '@mantine/core';
import { X } from 'react-feather';
import styles from './SurveyResultsModal.module.css';

interface SurveyResultsModalHeaderProps {
  groupName?: string;
  coachName?: string;
  onClose: () => void;
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function SurveyResultsModalHeader({
  groupName,
  coachName,
  onClose,
}: SurveyResultsModalHeaderProps) {
  const subtitle = groupName || 'All Participants & Groups';

  return (
    <div className={styles.header}>
      {/* Left: Title */}
      <div className={styles.titleArea}>
        <h3 className={styles.modalTitle}>Surveys & Feedback</h3>
        <p className={styles.modalSubtitle}>{subtitle}</p>
      </div>

      {/* Coach avatar (group-level only) */}
      {coachName && (
        <div className={styles.coachBox}>
          <div className={styles.coachAvatar}>{getInitials(coachName)}</div>
          <div className={styles.coachInfo}>
            <span className={styles.coachLabel}>Coach</span>
            <span className={styles.coachName}>{coachName}</span>
          </div>
        </div>
      )}

      {/* Close button */}
      <ActionIcon
        variant="subtle"
        color="gray"
        size="lg"
        onClick={onClose}
        className={styles.closeButton}
        aria-label="Close"
      >
        <X size={18} />
      </ActionIcon>
    </div>
  );
}

export default SurveyResultsModalHeader;
